import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'
import { OptimizelyClientSideExperiments, getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import { useIsLargeDesktopScreen } from 'lib/web/deviceUtils'
import { useLocation } from 'react-router'

const useSearchSplitView = () => {
  const isDesktop = useIsLargeDesktopScreen()
  const isSplitViewEnabled = config.ENABLE_SEARCH_SPLIT_VIEW
  const isMapPage = useLocation().pathname.includes('/map')

  const isExperimentEnabled = !!useAppSelector(state => getOptimizelyExperimentVariation(state, OptimizelyClientSideExperiments.searchMapSplitView))

  return isDesktop && isSplitViewEnabled && isExperimentEnabled && isMapPage
}

export default useSearchSplitView
